import React from 'react';
import { Idea as IdeaType } from '~/content/types';

import { highlightLinks } from '../Idea/helpers';

type UseIdeaInput = {
  idea: IdeaType;
  lines?: number;
};

type UseIdeaTextReturn = {
  text: JSX.Element;
};

export const useIdeaText = ({
  idea,
  lines = 11,
}: UseIdeaInput): UseIdeaTextReturn => {
  const textContent = { __html: highlightLinks(idea.content.text?.trim()) };

  return {
    text: (
      <div style={{ WebkitLineClamp: lines }} className="maxed_out">
        <p dangerouslySetInnerHTML={textContent} />
      </div>
    ),
  };
};
